import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsLeftRight: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm9 7-5 5 5 5' }],
    ['path', { d: 'm15 7 5 5-5 5' }],
  ],
];

export default ChevronsLeftRight;
